import qs from 'qs';
import request from './request';

// 查询用户可以转的拼多多转盘领奖活动(有可用转盘活动,且用户当天未参与该活动)
export const getActivityUsable = () =>
  request({
    url: '/activity/usable',
    method: 'GET'
  });
// 查询拼多多活动配置(是否开启-弹框时机-奖励配置-活动说明等）
export const getActivityConfiguration = () =>
  request({
    url: '/activity/configuration',
    method: 'GET'
  });
// 查询用户正在进行中的奖励
export const getActivityReward = () =>
  request({
    url: '/activity/reward/toward',
    method: 'GET'
  });
// 查询活动分享的手机号
export const getActivityMobiles = () =>
  request({
    url: '/activity/mobiles',
    method: 'GET'
  });
// 分页查询领取的活动奖励
export const getActivityRewardPage = data =>
  request({
    url: '/activity/reward/page',
    method: 'POST',
    data
  });
// 参与活动(转动拼多多活动转盘)
export const submitActivity = () =>
  request({
    url: '/activity/active',
    method: 'POST'
  });
// 对完成进度的奖励进行领取
export const withdrawReward = data =>
  request({
    url: '/activity/withdraw/reward',
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data: qs.stringify(data)
  });

// 抽奖次数历史列表
export const getRaffleTicketHistory = params =>
  request({
    url: '/activity/turntable/time/history',
    method: 'GET',
    params
  });

// 抽奖次数未完成列表
export const getRaffleTicketTasks = params =>
  request({
    url: '/activity/turntable/time/task',
    method: 'GET',
    params
  });

// 获取用户获奖记录
export const getRewardRecords = params =>
  request({
    url: '/activity/turntable/reward/page',
    method: 'GET',
    params
  });

// 领取抽奖次数奖励
export const receiveTaskReward = data =>
  request({
    url: '/activity/turntable/receive/time_type',
    method: 'POST',
    data
  });

// 领取转盘奖励
export const receiveWheelReward = data =>
  request({
    url: '/activity/turntable/receive/reward',
    method: 'POST',
    data
  });

// 被邀请人领取奖励
export const inviteeReceiveReward = data =>
  request({
    url: '/activity/turntable/receive/invitee',
    method: 'POST',
    data
  });


// 获取被邀请人奖励列表
export const getInviteeRewardList = () =>
  request({
    url: '/activity/turntable/invitee/rewards',
    method: 'GET',
  });


